import http from "../http-common"

class SiteMapServices {
    getSiteMap() {
        return http.get(`/sitemap`)
    }
}


export default new SiteMapServices();